import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ParamsService {
  public fromString(text: string): any {
    if (!text.match(/\?/) || !text.match(/\?\w+/)) {
      return {};
    } // no `?` or nothing after `?`
    const params: object = {};

    for (let paramString of text.replace(/.*\?/, '').split('&')) {
      if (!paramString.match(/\=/)) {
        params[paramString] = null;
        continue;
      } // set val to null if no `=` present
      const i = paramString.indexOf('=');
      let paramKey = decodeURIComponent(paramString.slice(0, i));
      let paramValue = decodeURIComponent(paramString.slice(i + 1));

      if (paramKey.match(/\[\]/)) {
        // if paramKey has an array key `foo[]`
        paramKey = paramKey.replace(/\[\]/, ''); // remove the `[]` from paramKey
        paramValue = params[paramKey]
          ? params[paramKey].concat([paramValue])
          : [paramValue];
      }
      params[paramKey] = paramValue;
    }
    return params;
  }

  public appendToString(text: string, params: object): string {
    if (!Object.keys(params).length) {
      return text;
    }

    const [baseUrl, fragment] = text.split('#');
    const urlWithParams = this.appendParamsToBaseUrl(baseUrl, params);
    return fragment ? `${urlWithParams}#${fragment}` : urlWithParams;
  }

  private appendParamsToBaseUrl(text: string, params: object): string {
    text = this.appendQueryStringOperatorTo(text);

    for (const paramKey of Object.keys(params)) {
      const prepender: string = text.match(/\?$/) ? '' : '&'; // prepend '&' unless text ends with a '?'

      if (params[paramKey] instanceof Array) {
        if (params[paramKey].length > 0) {
          if (paramKey.match(/\[\]$/)) {
            text +=
              prepender +
              params[paramKey]
                .map((item) => `${paramKey}=${encodeURIComponent(item)}`)
                .join('&');
          } else {
            text +=
              prepender +
              params[paramKey]
                .map((item) => `${paramKey}[]=${encodeURIComponent(item)}`)
                .join('&');
          }
        }
      } else if (params[paramKey] === '') {
        text += `${prepender}${paramKey}=""`; // must append the "" manually
      } else if (!params[paramKey] && params[paramKey] !== 0) {
        text += `${prepender}${paramKey}`;
      } else {
        text += `${prepender}${paramKey}=${encodeURIComponent(
          params[paramKey]
        )}`;
      }
    }
    return text;
  }

  public filterByKeys(
    paramsToFilter: object,
    keysToFilterBy: string[]
  ): object {
    if (!keysToFilterBy.length) {
      return paramsToFilter;
    }
    const filteredParams: object = {};
    for (const filterKey of keysToFilterBy) {
      if (paramsToFilter[filterKey]) {
        filteredParams[filterKey] = paramsToFilter[filterKey];
      }
    }
    return filteredParams;
  }

  public removeKeys(paramsToFilter: object, keysToRemove: string[]): object {
    if (keysToRemove.length === 0) {
      return paramsToFilter;
    }
    const filteredParams: object = {};
    const paramsToKeep = Object.keys(paramsToFilter).filter(
      (key) => !keysToRemove.includes(key)
    );
    paramsToKeep.forEach((key) => (filteredParams[key] = paramsToFilter[key]));
    return filteredParams;
  }

  private appendQueryStringOperatorTo(path: string): string {
    return path.match(/\?/) ? path : path + '?';
  }
}
